import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

function Carousel({
  children,
  autoPlay = false,
  autoPlayInterval = 3000,
  showIndicators = true,
  showArrows = true,
  length,
}) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalSlides = React.Children.count(children);
  const slideRef = useRef();

  const goToSlide = (index) => {
    const newIndex = (index + totalSlides) % totalSlides;
    setCurrentIndex(newIndex);
  };

  useEffect(() => {
    if (!autoPlay) return;

    const interval = setInterval(() => {
      goToSlide(currentIndex + 1);
    }, autoPlayInterval);

    // eslint-disable-next-line consistent-return
    return () => clearInterval(interval);
  }, [currentIndex, autoPlay, autoPlayInterval]);

  return (
    <div className="overflow-x-hidden overflow-y-visible w-full">
      {/* Slide wrapper */}
      <div
        ref={slideRef}
        className="flex transition-transform duration-500 ease-in-out"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {React.Children.map(children, (child) => (
          <div className="w-full flex-shrink-0">{child}</div>
        ))}
      </div>

      {/* Arrows */}
      {showArrows && (
        <>
          <button
            type="button"
            onClick={() => goToSlide(currentIndex - 1)}
            className="absolute top-1/2 left-2 transform -translate-y-1/2 bg-white rounded-full p-2 shadow"
          >
            ‹
          </button>
          <button
            type="button"
            onClick={() => goToSlide(currentIndex + 1)}
            className="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white rounded-full p-2 shadow"
          >
            ›
          </button>
        </>
      )}

      {/* Indicators */}
      {showIndicators && length > 1 && (
        <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2">
          {Array.from({ length: totalSlides }).map((_, i) => (
            <button
              type="button"
              // eslint-disable-next-line react/no-array-index-key
              key={i}
              aria-label="Previous Slide"
              onClick={() => goToSlide(i)}
              className={`w-3 h-2 rounded-full ${i === currentIndex ? 'bg-red-500 w-4' : 'bg-gray-300'
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
}

Carousel.defaultProps = {
  autoPlay: false,
  autoPlayInterval: 3000,
  showIndicators: true,
  showArrows: true,
  length: null,
};

Carousel.propTypes = {
  children: PropTypes.any.isRequired,
  autoPlay: PropTypes.any,
  autoPlayInterval: PropTypes.any,
  showIndicators: PropTypes.any,
  showArrows: PropTypes.any,
  length: PropTypes.number,
};

export default Carousel;
